import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import CenterTop from '@/components/layout/CenterTop.vue';
import Footer from '@/components/layout/Footer.vue';
import store from '@/store';
import PlatformPreview from '@/components/platform/PlatformPreview.vue';
import { PLATFORM_DELETE, PLATFORM_REFRESH, SETTINGS_LIST } from '@/store/actions/platforms';
import GridItem from '@/components/layout/GridItem.vue';
import { router } from "@/router";
import NumberAnimation from '@/components/numberAnimation/NumberAnimation.vue';
import SummaryItem from '@/components/platform/SummaryItem.vue';
import Separator from '@/components/layout/Separator.vue';
import { SummaryKey } from '@/store/enums/sumaryKeyEnum';
import SettingsPlatform from "@/views/platform/SettingsPlatform.vue";
import Banner from "@/components/banner/Banner.vue";
import IpWhitelistSettings from "@/views/platform/IPWhitelistSettings.vue";
var DetailPlatform = /*#__PURE__*/function (_Vue) {
  function DetailPlatform() {
    var _this;
    _classCallCheck(this, DetailPlatform);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DetailPlatform, [].concat(args));
    _defineProperty(_this, "platformID", void 0);
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "showApprovers", false);
    _defineProperty(_this, "overviewTabName", 'overview-tab');
    _defineProperty(_this, "settingsTabName", 'settings-tab');
    _defineProperty(_this, "ipWhitelistTabName", 'ip-whitelist-tab');
    _defineProperty(_this, "breadcrumbItems", []);
    _defineProperty(_this, "activeTabName", _this.overviewTabName);
    return _this;
  }
  _inherits(DetailPlatform, _Vue);
  return _createClass(DetailPlatform, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;
      this.breadcrumbItems = [{
        label: 'Manage platforms',
        isRouterLink: true,
        url: '/'
      }, {
        label: this.platform.name
      }];
      if (this.settingsPlatform(this.platformID)) {
        this.updateShowApprovers();
      } else {
        store.dispatch(SETTINGS_LIST, this.platform).then(function () {
          return _this2.updateShowApprovers();
        });
      }
    }
  }, {
    key: "nbSpeachPublishKey",
    get: function get() {
      return SummaryKey.NB_SPEACH_PUBLISH;
    }
  }, {
    key: "nbSpeachToPublishKey",
    get: function get() {
      return SummaryKey.NB_SPEACH_TO_PUBLISH;
    }
  }, {
    key: "nbSpeachToValidateKey",
    get: function get() {
      return SummaryKey.NB_SPEACH_TO_VALIDATE;
    }
  }, {
    key: "nbSpeachMakerKey",
    get: function get() {
      return SummaryKey.NB_SPEACH_MAKER;
    }
  }, {
    key: "nbApproverKey",
    get: function get() {
      return SummaryKey.NB_APPROVER;
    }
  }, {
    key: "nbUserKey",
    get: function get() {
      return SummaryKey.NB_USER;
    }
  }, {
    key: "nbAdminKey",
    get: function get() {
      return SummaryKey.NB_ADMIN;
    }
  }, {
    key: "nbConnectedMonthKey",
    get: function get() {
      return SummaryKey.NB_CONNECTED_THIS_MONTH;
    }
  }, {
    key: "nbNewSpeachMonthKey",
    get: function get() {
      return SummaryKey.NB_NEW_SPEACH_MONTH;
    }
  }, {
    key: "nbNewSpeachWeekKey",
    get: function get() {
      return SummaryKey.NB_NEW_SPEACH_WEEK;
    }
  }, {
    key: "nbNewSpeach3MonthKey",
    get: function get() {
      return SummaryKey.NB_NEW_SPEACH_3MONTH;
    }
  }, {
    key: "nbNewSpeach6MonthKey",
    get: function get() {
      return SummaryKey.NB_NEW_SPEACH_6MONTH;
    }
  }, {
    key: "nbSpeachUniqueRead1Week",
    get: function get() {
      return SummaryKey.NB_SPEACH_UNIQUE_READ_ONE_WEEK;
    }
  }, {
    key: "nbSpeachUniqueRead1Month",
    get: function get() {
      return SummaryKey.NB_SPEACH_UNIQUE_READ_ONE_MONTH;
    }
  }, {
    key: "nbSpeachUniqueRead3Months",
    get: function get() {
      return SummaryKey.NB_SPEACH_UNIQUE_READ_THREE_MONTHS;
    }
  }, {
    key: "nbSpeachUniqueRead6Months",
    get: function get() {
      return SummaryKey.NB_SPEACH_UNIQUE_READ_SIX_MONTHS;
    }
  }, {
    key: "nbUniqueReadDataExist",
    get: function get() {
      return store.getters.summary(this.platform) && (store.getters.summary(this.platform)[SummaryKey.NB_SPEACH_UNIQUE_READ_ONE_WEEK] || store.getters.summary(this.platform)[SummaryKey.NB_SPEACH_UNIQUE_READ_ONE_MONTH] || store.getters.summary(this.platform)[SummaryKey.NB_SPEACH_UNIQUE_READ_THREE_MONTHS] || store.getters.summary(this.platform)[SummaryKey.NB_SPEACH_UNIQUE_READ_SIX_MONTHS]);
    }
  }, {
    key: "isUserCanDisconnect",
    get: function get() {
      return store.getters.isRemoveConnexionAvailable;
    }
  }, {
    key: "speachAdminDashboardUrl",
    get: function get() {
      return this.platform.url + '/administration/dashboard';
    }
  }, {
    key: "getSpeachAdminDashboardUrlByPeriod",
    value: function getSpeachAdminDashboardUrlByPeriod(period) {
      return this.platform.url + '/administration/dashboard?period=' + period;
    }
  }, {
    key: "updateShowApprovers",
    value: function updateShowApprovers() {
      this.showApprovers = this.settingsPlatform(this.platformID).WORKFLOW_ENABLED;
    }
  }, {
    key: "settingsPlatform",
    value: function settingsPlatform(platformID) {
      return store.getters.settings(platformID);
    }
  }, {
    key: "goToPlatform",
    value: function goToPlatform() {
      window.open(this.platform.url, this.platform.platformID);
    }
  }, {
    key: "isSettingAvailable",
    get: function get() {
      return store.getters.isPlatformSettingsAvailable;
    }
  }, {
    key: "goToPlatformSpeachManagement",
    value: function goToPlatformSpeachManagement() {
      window.open(this.speachAdminUrl, this.platform.platformID);
    }
  }, {
    key: "goToPlatformUsersManagement",
    value: function goToPlatformUsersManagement() {
      window.open(this.userAdminUrl, this.platform.platformID);
    }
  }, {
    key: "speachAdminUrl",
    get: function get() {
      return "".concat(this.platform.url, "/administration/s/all");
    }
  }, {
    key: "speachAdminUrlByState",
    value: function speachAdminUrlByState(state) {
      return "".concat(this.speachAdminUrl, "?etatCoursSearchFilter=").concat(state);
    }
  }, {
    key: "userAdminUrl",
    get: function get() {
      return "".concat(this.platform.url, "/administration/listUser");
    }
  }, {
    key: "platformVersion",
    get: function get() {
      var _this$settingsPlatfor;
      return (_this$settingsPlatfor = this.settingsPlatform(this.platformID)) === null || _this$settingsPlatfor === void 0 ? void 0 : _this$settingsPlatfor.PLATFORM_VERSION;
    }
  }, {
    key: "isIPWhitelistingAvailable",
    get: function get() {
      return store.getters.isIPWhitelistingAvailable;
    }
  }, {
    key: "userAdminUrlByRole",
    value: function userAdminUrlByRole(role) {
      return "".concat(this.userAdminUrl, "?role=").concat(role);
    }
  }, {
    key: "platform",
    get: function get() {
      var platform = store.getters.platform(this.platformID);
      if (platform === undefined) {
        router.push('/');
      }
      return platform;
    }
  }, {
    key: "loadingStyle",
    get: function get() {
      return "color: ".concat(this.platform.color, ";animation: sand 5s infinite ease-in ;");
    }
  }, {
    key: "deleteMe",
    value: function deleteMe() {
      var _this3 = this;
      this.errorMsg = '';
      this.loading = true;
      store.dispatch(PLATFORM_DELETE, this.platform).then(function (resp) {
        _this3.loading = false;
        _this3.errorMsg = '';
      }).catch(function (err) {
        _this3.loading = false;
        _this3.errorMsg = err;
      });
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(tab) {
      this.activeTabName = tab.paneName;
    }
  }, {
    key: "refreshInformationPlatform",
    value: function refreshInformationPlatform() {
      var _this4 = this;
      this.loading = true;
      store.dispatch(PLATFORM_REFRESH, this.platform).then(function () {
        _this4.loading = false;
      }).catch(function () {
        _this4.loading = false;
      });
    }
  }]);
}(Vue);
__decorate([Prop()], DetailPlatform.prototype, "platformID", void 0);
DetailPlatform = __decorate([Options({
  components: {
    Separator: Separator,
    SummaryItem: SummaryItem,
    NumberAnimation: NumberAnimation,
    GridItem: GridItem,
    PlatformPreview: PlatformPreview,
    Footer: Footer,
    CenterTop: CenterTop,
    MainTitle: MainTitle,
    SettingsPlatform: SettingsPlatform,
    Banner: Banner,
    IpWhitelistSettings: IpWhitelistSettings
  }
})], DetailPlatform);
export default DetailPlatform;